export default __webpack_public_path__ + "static/media/logo.d002b08e.png";